import RefDetail from "@/components/RefDetail";
import { IWebSearch } from "logic/src/objects/chat/types";
import { Popover } from "antd";
import styles from "../index.module.scss";

const MyRef = ({
  index,
  webSearch,
}: {
  index: number;
  webSearch?: IWebSearch[];
}) => {
  const content = webSearch?.[Number(index) - 1];

  if (!content) {
    return null;
  }

  return (
    <Popover
      content={
        <RefDetail
          title={content.title || "引用内容"}
          content={content.passage_or_snippet}
          url={content.url}
          icon={content.icon}
          domain={content.domain}
        />
      }
    >
      <span className={styles.sensechatRef}>
        <span className={styles.sensechatRefInner}>{index}</span>
      </span>
    </Popover>
  );
};

export default MyRef;
